import React, { useState } from 'react';
import styled from 'styled-components';

const GalleryContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;

  @media screen and (max-width: 768px) {
    padding: 0 12px;
  }
`;

const SectionTitle = styled.h2`
  color: #010606;
  font-size: 24px;
  margin: 0px 0 12px;
  text-align: center;
  font-weight: 600;

  @media screen and (max-width: 768px) {
    font-size: 20px;
    margin: 0px 0 8px;
  }
`;

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: ${props => {
    if (props.section === 'twitter') {
      return 'repeat(3, 1fr)';
    }
    if (props.section === 'ooh') {
      return 'repeat(4, 1fr)';
    }
    if (props.section === 'partnerships') {
      return 'repeat(2, 1fr)';
    }
    if (props.section === 'adsManagement') {
      return 'repeat(3, 1fr)';
    }
    return 'repeat(5, 1fr)';
  }};
  gap: 8px;
  margin: 8px 0 24px;

  @media screen and (max-width: 768px) {
    grid-template-columns: ${props => {
      if (props.section === 'twitter') {
        return 'repeat(3, 1fr)';
      }
      if (props.section === 'ooh') {
        return 'repeat(4, 1fr)';
      }
      if (props.section === 'partnerships') {
        return 'repeat(2, 1fr)';
      }
      if (props.section === 'adsManagement') {
        return 'repeat(3, 1fr)';
      }
      return 'repeat(4, 1fr)';
    }};
    gap: 6px;
    margin: 6px 0 20px;
  }

  @media screen and (max-width: 480px) {
    grid-template-columns: ${props => {
      if (props.section === 'twitter') {
        return 'repeat(3, 1fr)';
      }
      if (props.section === 'ooh') {
        return 'repeat(4, 1fr)';
      }
      if (props.section === 'partnerships') {
        return 'repeat(2, 1fr)';
      }
      if (props.section === 'adsManagement') {
        return 'repeat(3, 1fr)';
      }
      return 'repeat(4, 1fr)';
    }};
    gap: 4px;
  }
`;

const MediaItem = styled.div`
  position: relative;
  width: 100%;
  padding-top: ${props => {
    if (props.section === 'partnerships' || props.section === 'adsManagement') {
      return '100%';
    }
    return '75%';
  }};
  overflow: hidden;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.03);
  }

  @media screen and (max-width: 768px) {
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    
    &:hover {
      transform: scale(1.02);
    }
  }

  img, video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: #f5f5f5;
  }
`;

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
`;

const ModalContent = styled.div`
  position: relative;
  max-width: 90%;
  max-height: 90vh;
  
  img, video {
    max-width: 100%;
    max-height: 90vh;
    object-fit: contain;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: white;
  font-size: 30px;
  cursor: pointer;
  padding: 5px;
  
  &:hover {
    color: #01bf71;
  }
`;

const MediaGallery = () => {
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [videoLoaded, setVideoLoaded] = useState({});

  const sections = {
    ooh: {
      title: "OOH and Public Advertisement",
      items: [
        { type: 'image', src: require('../../images/kishu.png'), alt: 'KISHU advertisement' },
        { type: 'video', src: require('../../images/russ.mp4'), alt: 'Russ video' },
        { type: 'image', src: require('../../images/brent1.png'), alt: 'Brent advertisement 1' },
        { type: 'image', src: require('../../images/brent2.png'), alt: 'Brent advertisement 2' },
        { type: 'image', src: require('../../images/brent3.png'), alt: 'Brent advertisement 3' },
        { type: 'image', src: require('../../images/mogul1.png'), alt: 'Mogul advertisement 1' },
        { type: 'image', src: require('../../images/mogul2.png'), alt: 'Mogul advertisement 2' },
        { type: 'image', src: require('../../images/mogul3.png'), alt: 'Mogul advertisement 3' },
        { type: 'image', src: require('../../images/sonder.png'), alt: 'Sonder advertisement' },
        { type: 'image', src: require('../../images/sonder2.png'), alt: 'Sonder advertisement 2' },
        { type: 'image', src: require('../../images/ooh_01.PNG'), alt: 'OOH advertisement 1' },
        { type: 'image', src: require('../../images/ooh_02.PNG'), alt: 'OOH advertisement 2' }
      ]
    },
    twitter: {
      title: "Twitter Trending",
      items: [
        { type: 'image', src: require('../../images/twitter_ad.png'), alt: 'Twitter advertisement' },
        { type: 'image', src: require('../../images/unique_07.PNG'), alt: 'Unique content 7' },
        { type: 'image', src: require('../../images/unique_03.PNG'), alt: 'Unique content 3' },
        { type: 'image', src: require('../../images/unique_04.PNG'), alt: 'Unique content 4' },
        { type: 'image', src: require('../../images/unique_05.PNG'), alt: 'Unique content 5' },
        { type: 'image', src: require('../../images/unique_06.PNG'), alt: 'Unique content 6' },
        { type: 'image', src: require('../../images/unique_02.PNG'), alt: 'Unique content 2' },
        { type: 'image', src: require('../../images/unique_01.PNG'), alt: 'Unique content 1' },
        { type: 'image', src: require('../../images/unique_021.PNG'), alt: 'Unique content 2.1' }
      ]
    },
    partnerships: {
      title: "Influencer Partnerships",
      items: [
        { type: 'video', src: require('../../videos/jackd.mp4'), alt: 'Influencer partnership - JackD' },
        { type: 'video', src: require('../../videos/morgan.mp4'), alt: 'Influencer partnership - Morgan' },
        { type: 'video', src: require('../../videos/ireland.mp4'), alt: 'Influencer partnership - Ireland' },
        { type: 'video', src: require('../../videos/colty.mp4'), alt: 'Influencer partnership - Colty' },
        { type: 'video', src: require('../../videos/reif.mp4'), alt: 'Influencer partnership - Reif' },
        { type: 'image', src: require('../../images/partnership_01.PNG'), alt: 'Partnership showcase' },
        { type: 'image', src: require('../../images/snapmetrics.jpg'), alt: 'Snapmetrics partnership showcase' }
      ]
    },
    adsManagement: {
      title: "Ads Management",
      items: [
        { type: 'image', src: require('../../images/79h62qd.png'), alt: 'Ads management 1' },
        { type: 'image', src: require('../../images/797dxdb.png'), alt: 'Ads management 2' },
        { type: 'image', src: require('../../images/textads.jpg'), alt: 'Text ads management showcase' }
      ]
    }
  };

  const handleMediaClick = (item) => {
    setSelectedMedia(item);
  };

  const handleCloseModal = () => {
    setSelectedMedia(null);
  };

  // Close modal when clicking outside the image
  const handleModalClick = (e) => {
    if (e.target === e.currentTarget) {
      handleCloseModal();
    }
  };

  const handleVideoLoad = (index) => {
    setVideoLoaded(prev => ({ ...prev, [index]: true }));
  };

  return (
    <GalleryContainer>
      {Object.entries(sections).map(([key, section]) => (
        <div key={key}>
          <SectionTitle>{section.title}</SectionTitle>
          <GalleryGrid section={key}>
            {section.items.map((item, index) => (
              <MediaItem 
                key={index} 
                onClick={() => handleMediaClick(item)}
                section={key}
              >
                {item.type === 'image' ? (
                  <img src={item.src} alt={item.alt} loading="lazy" />
                ) : (
                  <video 
                    controls
                    muted
                    preload="metadata"
                    onLoadedData={() => handleVideoLoad(`${key}-${index}`)}
                    title={item.alt}
                    aria-label={item.alt}
                    style={{
                      opacity: videoLoaded[`${key}-${index}`] ? 1 : 0.7,
                      transition: 'opacity 0.3s ease'
                    }}
                  >
                    <source src={item.src} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                )}
              </MediaItem>
            ))}
          </GalleryGrid>
        </div>
      ))}

      {selectedMedia && (
        <Modal onClick={handleModalClick}>
          <ModalContent>
            <CloseButton onClick={handleCloseModal}>&times;</CloseButton>
            {selectedMedia.type === 'image' ? (
              <img src={selectedMedia.src} alt={selectedMedia.alt} />
            ) : (
              <video 
                controls
                autoPlay
                title={selectedMedia.alt}
                aria-label={selectedMedia.alt}
              >
                <source src={selectedMedia.src} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
          </ModalContent>
        </Modal>
      )}
    </GalleryContainer>
  );
};

export default MediaGallery; 